import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { DiscountCatalog } from './useDiscountCatalog';

interface MenuGateProps {
  catalog: DiscountCatalog;
  /** Высота заглушки, пока меню грузится: карточка не прыгает. */
  skeletonHeight?: number;
  children: React.ReactNode;
}

/** Дерево меню показывается, только когда меню загружено; иначе — заглушка или повтор. */
export function MenuGate({ catalog, skeletonHeight = 160, children }: MenuGateProps) {
  const { t } = useLanguage();

  if (catalog.status === 'loading') {
    return (
      <div
        className="qp-skel"
        style={{ height: skeletonHeight }}
        role="status"
        aria-label={t.discounts.menuLoading}
      />
    );
  }

  if (catalog.status === 'error') {
    return (
      <div className="qp-notice qp-notice--error" role="alert">
        <span style={{ flex: 1 }}>{t.discounts.menuError}</span>
        <button type="button" className="qp-btn qp-btn--sm qp-btn--outline" onClick={catalog.reload}>
          {t.discounts.menuRetry}
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
